module.exports = __webpack_public_path__ + "static/media/brown-shoe.8881a235.jpeg";